module.exports = __webpack_public_path__ + "00687838302e3bd21fce42d8b9bee3ae.pdf";